import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import UserService from '../../services/userService';
import { ToastType, useToast } from '../toast/ToastProvider';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '', redirectUrl: window.location.origin });
    const { showToast } = useToast();
    const { i18n } = useTranslation();
    const isRtl = i18n.language === 'he';

    useEffect(() => {
        // Load saved email from sessionStorage
        const savedEmail = localStorage.getItem('rememberedEmail');
        if (savedEmail) {
            setFormData((prev) => ({ ...prev, email: savedEmail }));
        }
    }, []);    

    const handleNavigateToRegister = () => {
        navigate('/register');
    };

    const handleNavigateToLogin = () => {
        navigate('/login');
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const handleForgotPassword = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await UserService.forgotPassword(formData);
            
            if (response.status === "reset_link_sent") {
                showToast(t(`toastMessages.RESET_LINK_IF_EMAIL_EXISTS`), ToastType.Success);
            }
        } catch (error: any) {
            showToast(t(`toastMessages.RESET_LINK_IF_EMAIL_EXISTS`), ToastType.Success);
        }
    };

    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="row w-100 m-0">
                    <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
                        <div className="card col-lg-4 mx-auto">
                            <div className="card-body px-5 py-5">
                                <h3 className="card-title text-left mb-3">{t('forgot-password')}</h3>
                                <form>
                                    <div className="form-group">
                                        <label className="text-gray">{t('email')}</label>
                                        <input type="email" placeholder={t('email')} value={formData.email} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="email" />
                                    </div>
                                    <div className="text-center mt-5">
                                        <button type="submit" onClick={handleForgotPassword} className="btn btn-primary btn-block enter-btn">{t('send-password-reset-email')}</button>
                                    </div>
                                    <p className="sign-up">
                                        <a className="btn btn-link" onClick={handleNavigateToRegister}> {t('register')}</a>
                                        <a className="btn btn-link" onClick={handleNavigateToLogin}> {t('login')}</a>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
